export default __webpack_public_path__ + "static/media/illustration_gamer-insights_inactive.70e69e3a.png";